import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  startArchieChat,
  continueArchieChat,
  listArchieConversations,
  getArchieConversationMessages,
} from "../api/archie";
import {
  ArchieNewChatRequest,
  ArchieContinueChatRequest,
} from "../types/archie/archie";

export const useStartArchieChat = () => {
  return useMutation({
    mutationFn: (request: ArchieNewChatRequest) => startArchieChat(request),
  });
};

export const useContinueArchieChat = () => {
  return useMutation({
    mutationFn: ({
      conversationId,
      request,
    }: {
      conversationId: string;
      request: ArchieContinueChatRequest;
    }) => continueArchieChat(conversationId, request),
  });
};

export const useListArchieConversations = (
  customerId: string | undefined,
  userId: string | undefined
) => {
  return useQuery({
    queryKey: ["archieConversations", customerId, userId],
    queryFn: () => listArchieConversations(customerId!, userId!),
    enabled: !!customerId && !!userId,
  });
};

export const useLoadArchieConversation = () => {
  return useMutation({
    mutationFn: (conversationId: string) =>
      getArchieConversationMessages(conversationId),
  });
};

export const useInvalidateArchieConversations = () => {
  const queryClient = useQueryClient();
  return (customerId: string, userId: string) => {
    queryClient.invalidateQueries({
      queryKey: ["archieConversations", customerId, userId],
    });
  };
};
